import { Component, ElementRef, Injector, Input, ChangeDetectionStrategy } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

/**
 * Component wrapper for RelationsController
 */
@Component({
  selector: 'relations-list',
  template: '<relations-list-directive></relations-list-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RelationsListComponent {
}

/**
 * Directive for downgrading RelationsListComponent
 */
@Component({
  selector: 'relations-list-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RelationsListDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('relationsList', elementRef, injector);
  }
}

/**
 * Component wrapper for RelationController
 */
@Component({
  selector: 'relation-form',
  template: '<relation-form-directive [id]="id"></relation-form-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RelationFormComponent {
  @Input() id: string;
}

/**
 * Directive for downgrading RelationFormComponent
 */
@Component({
  selector: 'relation-form-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RelationFormDirective extends UpgradeComponent {
  @Input() id: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('relation', elementRef, injector);
  }
}

/**
 * Component wrapper for RelationsReorderController
 */
@Component({
  selector: 'relations-reorder',
  template: '<relations-reorder-directive></relations-reorder-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RelationsReorderComponent {
  constructor() {}
}

/**
 * Directive for downgrading RelationsReorderComponent
 */
@Component({
  selector: 'relations-reorder-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RelationsReorderDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('relationsReorder', elementRef, injector);
  }
}
